import { PluginNotInstalledError, PluginNotAvailableError } from './errors';

import './thirdparty/cadesplugin_api';


if (window.cadesplugin)
    window.cadesplugin.set_log_level(window.cadesplugin.LOG_LEVEL_ERROR);

export const call = func => async (...args) => {
    if (!window.cadesplugin)
        throw new PluginNotInstalledError();

    try {
        await window.cadesplugin;
    } catch (err) {
        console.log(err);
        throw new PluginNotAvailableError();
    }

    return func(...args);
};
